import React from 'react';
import PropTypes from 'prop-types';

const formatThumbnailUrl = url => (
  (url.indexOf('1024px') !== -1) ? url.replace(/1024px/, '360px') : url
);

const MediaGalleryImage = ({ image, handleMediaClick }) => (
  <div id={`image-${image.id}`} data-props={`Image,${image.productLineName},${image.colorRange},${image.designStyle},${image.roomType}`} data-description={image.description} data-product-url={image.productLineUrl} data-image-url={image.imageUrl}>
    <button type="button" className="gallery-modal-toggle" aria-expanded={image.active} aria-label={`Show details for ${image.imageUrl.substr((image.imageUrl.lastIndexOf('/') + 1))}`} aria-controls={`${image.title.toLowerCase().replace(/[\s]+/g, '-')}-modal`} onClick={() => handleMediaClick(image)}>
      <img className="lazy" data-src={formatThumbnailUrl(image.imageUrl)} alt="" />
    </button>
  </div>
);

MediaGalleryImage.propTypes = {
  handleMediaClick: PropTypes.func.isRequired,
  image: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    active: PropTypes.bool,
    productLineId: PropTypes.string,
    productLineName: PropTypes.string,
    productLineUrl: PropTypes.string,
    colorRange: PropTypes.string,
    designStyle: PropTypes.string,
    roomType: PropTypes.string,
  }),
};

export default MediaGalleryImage;
